import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Vue from 'vue';
import VueLazyLoad from 'vue-lazyload';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from './router';
import store from './store';
import mixin from './global_mixin';
import 'vue-material-design-icons/styles.css';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://9bae0efe4b284b198417ed744b17a6bb@errors.danemco.net/76',
    integrations: [new Integrations.Vue({ Vue })],
  });
}

Vue.config.productionTip = false;
Vue.config.devtools = false;

Vue.use(VueMeta);
Vue.use(VueLazyLoad);
Vue.mixin(mixin);

window.app = new (Vue.extend(App))({
  router,
  store,
}).$mount('#app');
